import styled from 'styled-components'

export default styled.div`
  background: #D8DCE5;
  height: 12.5px;
  align-self: center;
  flex: 1;
`



// WEBPACK FOOTER //
// ./src/components/DashboardWidgets/UsersActivity/Row/ProgressBar.js